import React from 'react';
import { observer, inject } from "mobx-react";
import { Input, InputFile, SelectInput, Collapsible, DatePicker, InputValidation, Table, Chips, Accordion, Spinner, Pagination,Modal  } from '@sogei/react-web-components-catalog'
import { breadcrumbRicevutePegno, breadcrumbTrasmissionePegno } from '../../assets/breadcrumb';
import { tableHeadPegni,tableHeadUnico ,tableHeadPegniCertificati, tableHeadCancIpotecaElenchi, tableHeadCancIpotecaPrimoLivello} from '../../assets/tableHeaders';
import i18next from 'i18next';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { AppButton } from '../commons/button';
import { decodeTipologica, scrollToTop } from '../commons/uiUtils';
import { regExpDate, regExpOnlyNumbers } from '../../assets/utils/regexp';
import { RicevutaFirmataENon } from '../ricevute/ricevutaFirmataENon';
import { DownloadDocumento } from '../ricevute/downloadDocumento';
import { DatiRicerca } from '../ricevute/datiRicerca';
import { DettaglioButton } from '../ricevute/dettaglioButton';
import { isFromElenchi } from '../../assets/utils/queryParams';
import { FornituraOnDemandCI } from '../ricevute/fornituraOnDemandCI';



@inject("rootStore")
@observer
class Ricevute extends React.Component {

  constructor(props) {
    super(props);
    this.tipologicaStore = props.rootStore.tipologicaStore;
    this.ricevuteStore = props.rootStore.ricevuteStore;
    this.qualificheStore = props.rootStore.qualificheStore;
    this.tipoPratica = this.qualificheStore.tipoPratica;
    
  
  }

  navigateToDettaglio = (ricevuta, tipoPratica) => {
    this.ricevuteStore.loadAndNavigateToSecondoLivello(this.formikRef.state.values, ricevuta, tipoPratica);
  }

  componentWillUnmount()
   {
    this.ricevuteStore.ricevute = undefined;
  }

    render() {    
   

      const pagination = this.ricevuteStore.pagination
      const filtriRicerca = this.ricevuteStore.filtriRicerca;
      const listaStatiInvio = this.tipologicaStore.statoInvio;
      const ricevute = this.ricevuteStore.ricevute;
      const ricevutePaginated = this.ricevuteStore.ricevute ? this.ricevuteStore.ricevute.slice(pagination.start,pagination.start + pagination.limit) : [];
      const loading = this.ricevuteStore.loading;

      
    

    
    const tableHead = (tableHeader)=>{
      //console.log(tableHeader)
      let thLivello1 = tableHeader.filter(x => x.livello==1 ).map( cellaHeader => {
        const cella = <th style={{verticalAlign:"middle"}} className= {cellaHeader.classNameHeader}  colSpan={cellaHeader.colSpan} rowSpan={cellaHeader.rowSpan}> {i18next.t(cellaHeader.label)} </th>
        return cella;
      })

      let thLivello2 = tableHeader.filter(y => y.livello==2 ).map( cellaHeader => {
        const cella = <th style={{verticalAlign:"middle"}} className= {cellaHeader.classNameHeader}  colSpan={cellaHeader.colSpan} rowSpan={cellaHeader.rowSpan}> {i18next.t(cellaHeader.label)} </th>
        return cella;
      })
      
      let output = 
      <>
        <tr> {thLivello1}
      </tr>
      <tr> {thLivello2}
      </tr>
    
      </>
      return output;
  }

  const documentIcon = (border, icon, iconStyle, spanSrOnly, onClick,titolo) => {
    let customClass = 'btn btn-light border ' + border;
    let iconCenter = icon + ' ' + iconStyle;
    return <AppButton color="none" spanSrOnly={i18next.t(spanSrOnly)} customClass={customClass} iconCenter={iconCenter} type="button"  onClick={onClick} titleKey='' extraProps={{title:i18next.t(titolo)}}/>
  }
  /*const dettaglioButton = (item) =>{
    if((item.statoPratica == '11' || (this.tipoPratica=== 'UN' && item.statoPratica === '22')))
      return <AppButton spanSrOnly="BUTTON_VAI_A_DETTAGLIO" color="outlined-blu" type="button" iconCenter="fas fa-eye" onClick={() => this.navigateToDettaglio(item)} titleKey=''/>
    else
      return undefined
  }*/
  
  const downloadButton = (item,element )=> {
    if(
      (!item.condizione?true:item[element.nomeKeyServizio]==item.condizione) && item[element.file]){
        let downloadParam
        if( item[element.file] instanceof Object ){
          downloadParam = {fileMetaData: item[element.file]};
          
        }
        else {
          downloadParam = {idFile: item[element.file]};
          
        }
    return documentIcon(
      element.warning?
        item[element.nomeKeyServizio] == element.warning ? 'border-warning' : 'border-danger'
        :
        'border-info',
        element.icon,
        element.warning?
        item[element.nomeKeyServizio] == element.warning ? 'icon-warning' : 'icon-danger'
        :
        'icon-info',
        element.spanSrOnly,
        () => {this.ricevuteStore.downloadFile(downloadParam)},
        '')
      }
      else return undefined;


  }

  const servizioStatoPratica = (item,index) =>  {
    let erroreUtente = this.ricevuteStore.erroreUtente
    let colonnaStato;
    colonnaStato =  " ";
    //if((item.statoPegno==13||item.statoPegno==14||item.statoPegno==15)&&item.erroreUtente!='-') {
      if(item.statoPegno>10&&item.erroreUtente!='-') {
      console.log('item.idPratica||:item.statoPegno||item.erroreUtente:',item.idPratica,': ',item.statoPegno,item.erroreUtente);
     
      colonnaStato =  <>
      <Modal labelId="label" containerId="containerIdStatoPratica" title="Motivazione scarto" body={
         <p>
              {erroreUtente === undefined ? "" : erroreUtente}
            </p> 
            }>
        {" "}
      </Modal>           
      <button type="button" className="btn btn-light border border-danger" data-toggle="modal" data-target="#containerIdStatoPratica" onClick={() => this.ricevuteStore.messaggioErrore(item.erroreUtente)}>
            {item.descStato}
      </button>             
      </> 



    }
   /*  else if((item.stato==2&&item.esito==3&&!item.duplo)||(item.stato==1&&item.esito==0&&!item.duplo)) {
      colonnaStato =  <>
      <Modal labelId="label" containerId="containerIdStatoPratica" title="Stato pratica" body={
            <p>
              {statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.esito != 0 ? "Servizio di recupero dello stato non disponibile, si prega di riprovare più tardi." : "Domanda del pegno depositata presso l'ufficio in data: "} <b>{statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.dataRicezione} {statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.statoLavorazione == 1 ? ", in lavorazione" : ""}</b>
            </p>
            }>
        {" "}
      </Modal>           
      <button type="button" className="btn btn-light border" data-toggle="modal" data-target="#containerIdStatoPratica"  onClick={() => this.ricevuteStore.chiamataStatoPratica(item)}>
            {item.descStatoElaborazione}
      </button>             
      </> 
    } */
    else {
      colonnaStato= '-';//item.descStato'';
    }
    return colonnaStato;
  }
 /*  const servizioStatoPratica = (item) =>  {
      
    let colonnaStato;
console.log('item.idPratica||:item.statoPegno||item.erroreUtente:',item.idPratica,': ',item.statoPegno,item.erroreUtente);
    if((item.statoPegno==13||item.statoPegno==14||item.statoPegno==15)&&item.erroreUtente!='-') {
      console.log('dentro ifitem.idPratica||:item.statoPegno||item.erroreUtente:',item.idPratica,': ',item.statoPegno,item.erroreUtente);
      colonnaStato =  <>
      <Modal labelId="label" containerId="containerIdMotivoRifiuto" title="Motivazione scarto" body={
        <p>
          { item.erroreUtente}
       </p>
       }>
   {" "}
      </Modal>        
      <button type="button" className="btn btn-light border border-danger" data-toggle="modal" data-target="#containerIdMotivoRifiuto">
          {item.descStato}
       </button>             
      </> 
    }
    else {
      colonnaStato= '-';//item.descStato'';
    }
    return colonnaStato;
  } */
/*



*/     

  const tableBody = tableHeader =>
  
  {
    if(ricevutePaginated === undefined || ricevutePaginated.length == 0)
     return (<tr><td colSpan="10" key={ricevutePaginated.length}><span>{i18next.t("TABLE_NO_RESULTS")}</span></td></tr>)
    else
   {
     
   const output=  ricevutePaginated.map((item,index) => { return (
      <tr key={'result_'+item.idPratica+'_'+index}>
       {tableHeader.filter(z => z.type!=='td-none').map(element => {
       
        return <td className={element.classNameCella}>{
          element.type==='text'?item[element.nomeKeyServizio]
          :
          element.type==='dettaglio'? <DettaglioButton item= {item} element = {element} valori = {this.formikRef?this.formikRef.state.values:this.ricevuteStore.filtriRicercaStored} tipoPratica = {this.tipoPratica} livelloTarget={2}/>
          :
          element.type==='ricevutaFirmataENon'?  <RicevutaFirmataENon item={item} element = {element}/>
          :
          element.type==='downloadDocumento'? <DownloadDocumento item={item} element = {element}></DownloadDocumento>
          :
          element.type==='downloadDocumentoAtmos'? <DownloadDocumento item={item} element = {element}></DownloadDocumento>
          :
          element.type==='servizioStatoPratica'? servizioStatoPratica(item,index)
          :
          
          element.type==='fornituraOnDemandCI'? <FornituraOnDemandCI item={item} element = {element} annoMese ={  this.ricevuteStore.annoRicerca + item.codMese}></FornituraOnDemandCI>
          :
          undefined}
          </td>
        
       })
       } 
      </tr>
  )
  })
  return output;

  
  }

  }
  const getChipsFilter = (label, title, buttonCaption, onClick) => {
    return <Chips
        label={label}
        type="primary"
        title={title}
        buttonCaption={buttonCaption}
        chipIconClass="fas fa-filter"
        buttonIconClass="fas fa-times icon-danger"
        onClick={onClick}
        large={false}
        rootClass={['mx-1']}
    />
  }

  const getDateFilter = () => {
    if(!this.formikRef || !this.formikRef.state || !this.formikRef.state.values) {
      return;
    }
    if (!this.formikRef.state.values.dataDa && !this.formikRef.state.values.dataA) {
      return undefined;
    }
    let label = i18next.t("CHIPS_FILTRO_DATE",this.formikRef.state.values);
    let title = i18next.t("BUTTON_RIMUOVI_FILTRO");
    let buttonCaption = i18next.t("BUTTON_RIMUOVI_FILTRO");
    return getChipsFilter(label, title, buttonCaption ,() => {
      this.formikRef.getFormikActions().setFieldValue('dataA','',false);
      this.formikRef.getFormikActions().setFieldValue('dataDa','',false);
      this.formikRef.getFormikActions().submitForm();
    });
  }
  
  const getCodiceInvioFilter = () => {
    if(!this.formikRef || !this.formikRef.state || !this.formikRef.state.values) {
      return;
    }
    if (!this.formikRef.state.values.idPraticaDa && !this.formikRef.state.values.idPraticaA) {
      return undefined;
    }
    let label = i18next.t("CHIPS_FILTRO_CODICE_INVIO",this.formikRef.state.values);
    let title = i18next.t("BUTTON_RIMUOVI_FILTRO");
    let buttonCaption = i18next.t("BUTTON_RIMUOVI_FILTRO");
    return getChipsFilter(label, title, buttonCaption ,() => {
      this.formikRef.getFormikActions().setFieldValue('idPraticaA','',false);
      this.formikRef.getFormikActions().setFieldValue('idPraticaDa','',false);
      this.formikRef.getFormikActions().submitForm();
    });
  }

  const getStatoInvioFilter = () => {
    if(!this.formikRef || !this.formikRef.state || !this.formikRef.state.values) {
      return;
    }
    if (!this.formikRef.state.values.statoPratica) {
      return undefined;
    }
    let label = decodeTipologica(listaStatiInvio,this.formikRef.state.values,"statoPratica");
    let title = i18next.t("BUTTON_RIMUOVI_FILTRO");
    let buttonCaption = i18next.t("BUTTON_RIMUOVI_FILTRO");
    return getChipsFilter(label, title, buttonCaption ,() => {
      this.formikRef.getFormikActions().setFieldValue('statoPratica','',false);
      this.formikRef.getFormikActions().submitForm();
    });
  }

  const determinaTitoloPagina = () =>{
    if(!this.props.isElenchi){
      return "RICEVUTE_TITLE";
    }
    else{
      return "ELENCHI_TITLE";
    }
  }
  
        
        return (
          <div className="container-fluid pr-3 pl-3 pb-3">
           <div className="row">              
              <div className="col">
                <h1>{i18next.t(determinaTitoloPagina())}</h1>
                <DatiRicerca tipoPratica = {this.tipoPratica} isFromElenchi = {this.props.isElenchi} ></DatiRicerca>
                <Formik
        ref={(ref) => this.formikRef = ref}
        initialValues={{
         
          openIndex: filtriRicerca ? filtriRicerca.openIndex :  0,
          pagination: pagination
        }}></Formik>

              
                
                {loading && <Spinner isLoading={true}> </Spinner>}
                {ricevute !== undefined && (<>
                  <div className='row align-items-center'>
                  {/*<div className='col'>
                      <span>{i18next.t("FILTRI_APPLICATI")}</span>
                      {getDateFilter()}
                      {getCodiceInvioFilter()}
                      {getStatoInvioFilter()}
                    </div>*/}
                  </div>
                  <div className='row mt-3'>
                      <div className='col'>
                      <Table tableHead={tableHead(
                        this.tipoPratica === 'MP' ? tableHeadPegni
                        :
                        this.tipoPratica === 'UN'? tableHeadUnico
                        :
                        this.tipoPratica === 'CP'? tableHeadPegniCertificati
                        :
                        this.tipoPratica === 'CI' &&  this.props.isElenchi ? tableHeadCancIpotecaElenchi
                        :
                        this.tipoPratica === 'CI' ? tableHeadCancIpotecaPrimoLivello
                        :
                        undefined)} tableBody={ tableBody(
                          this.tipoPratica === 'MP' ? tableHeadPegni
                          :
                          this.tipoPratica === 'UN'? tableHeadUnico
                          :
                          this.tipoPratica === 'CP'? tableHeadPegniCertificati
                          :
                          this.tipoPratica === 'CI' && this.props.isElenchi ? tableHeadCancIpotecaElenchi
                          :
                          this.tipoPratica === 'CI' ? tableHeadCancIpotecaPrimoLivello
                          :
                          undefined)} tableOptions={['table-header']} />
                      </div>
                  </div>
                  {ricevute.length > pagination.limit && (<div className='row'>
                    <div className='col'>
                      <Pagination
                          total={ricevute.length}
                          limit={pagination.limit}
                          pageCount={pagination.pageCount}
                          displayPage={pagination.page}
                          onPageChange={(start, end, page) => {
                            this.ricevuteStore.updatePagination(start, end, page)
                          }}
                      >
                          {" "}
                      </Pagination>
                    </div>
                  </div>)}
                </>)}
              </div>
            </div>
          </div>
        ); 
      }
}


export default Ricevute

export { Ricevute }

